import { TimelinePipe } from "@pnp/core";
import { Picker } from "../Picker";

export function Setup(): TimelinePipe<Picker> {

    return (instance: Picker) => {

        // @ts-ignore
        instance.on.init(function (this: Picker) {
            window.addEventListener("message", (event) => {
                if (event.source && event.source === this.window) {
                    const message = event.data;
                    if (message.type === "initialize" && message.channelId === this.options.messaging.channelId) {
                        this.port = event.ports[0];
                        this.port.addEventListener("message", (event) => Reflect.apply(this.messageListener, this, [event]));
                        this.port.start();
                        this.port.postMessage({type: "activate",});
                    }
                }
            });
        });

        // @ts-ignore
        instance.on.dispose(function (this: Picker) {
            if (this.port) {
                this.port.close();
            }
        });

        return instance;
    };
}
